export enum Engine { Retail = 'Retail', Marketplace = 'Marketplace', Secondlife = 'SecondLife' }
